import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PlayCircle"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM8.6175 17.1451C8.73327 17.2137 8.86539 17.25 9 17.2501C9.12687 17.2566 9.25333 17.2308 9.3675 17.1751L17.6175 12.6751C17.8601 12.5441 18.0113 12.2907 18.0113 12.0151C18.0113 11.7394 17.8601 11.486 17.6175 11.3551L9.3675 6.85506C9.13545 6.72108 8.84955 6.72108 8.6175 6.85506C8.38973 6.99011 8.25005 7.23526 8.25 7.50006V16.5001C8.25005 16.7649 8.38973 17.01 8.6175 17.1451ZM15.6825 12.0001L9.75 15.2401V8.76006L15.6825 12.0001Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PlayCircle.vue"]]);
